import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleSaleProjection: (field: string, value: any) => void;
};

export default function ProjectedPhysicalIOFormGroup({
  album,
  readonly,
  disabled,
  fieldHasErrors,
  findErrorMessage,
  handleSaleProjection,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.projectedPhysicalIO')}
        handleInput={(e) =>
          handleSaleProjection('projectedPhysicalIO', e.target.value)
        }
        id="projectedPhysicalIO"
        type="text"
        min={0}
        unsignedIntegerOnly
        value={
          album.albumMetaData?.salesProjection?.projectedPhysicalIO?.toString() ??
          ''
        }
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('ProjectedPhysicalIO')}
        errorMessage={findErrorMessage('ProjectedPhysicalIO')}
      />
    </div>
  );
}
